/**
 * Route definition for /deploy
 * Renders the DeployContainer component.
 *
 * @module routes/deploy
 * @category Routes
 */
import { createFileRoute } from '@tanstack/react-router'
import DeployContainer from "@/containers/Deploy";

export const Route = createFileRoute('/$locale/deploy')({
  component: Deploy,
})

/**
 * Deploy page component.
 * Renders the Deploy container for NFT contract deployment.
 *
 * @returns {React.ReactElement}
 */
function Deploy() {


  return (
    <>
      <DeployContainer/>
    </>
  )
}